import { EmptyQueryResults } from '@/components/emptyQueryResults';

type ExpertNotFoundProps = {
  onBrowse: () => void;
};

/**
 * Shown in place of the inquiry form when the expert in the link does not exist. A form
 * addressed to nobody cannot be submitted, so the only useful next step is the directory.
 */
export function ExpertNotFound({ onBrowse }: ExpertNotFoundProps) {
  return (
    <EmptyQueryResults
      title="Expert not found"
      text="This expert may have been removed, or the link may be out of date."
      cta="Browse experts"
      onCtaPress={onBrowse}
    />
  );
}
